// @flow

import { useMutation, } from '@apollo/react-hooks';
import { kioskClient } from '../api/graphql';
import gql from 'graphql-tag';

const CHANGE_PASSWORD_MUTATION = gql`
mutation ChangePassword($input: ChangePasswordInput!) {
  changePassword(input: $input) {
    user {
      id
    }
  }
}`;

export const useChangePassword = () => {
  const [changePasswordMutation, { loading, error, reset }] = useMutation(
    CHANGE_PASSWORD_MUTATION,
    { client: kioskClient }
  );

  const changePassword = async (currentPassword, newPassword) => {
    try {
      const result = await changePasswordMutation({
        variables: {
          input: {
            currentPassword,
            newPassword,
          },
        },
      });
      return result.data?.changePassword.user;
    } catch (err) {
      throw err;
    }
  };

  return {
    changePassword,
    loading,
    error,
    reset,
  };
};
